export const IPaymentCard = {
  payment_type: 'Card',
  display_brand: 'Visa',
  exp_month: 11,
  exp_year: 2028,
  last4: '1111',
}

export const IBusinessAccount = {
  first_name: 'Reza',
  surname: 'Reza Samiei',
  images: ['1'],
  business_name: 'Testing Business',
  business_type: 0,
  email: 'c1@rezasamiei.com',
  country_code: 'uk',
  currency_code: 'gbp',
  language_code: 'en-gb',
  timezone: 'Europe/London',
  billing_address: {
    line1: '17 Hammersmith Road',
    line2: 'Work Life',
    city: 'London',
    postcode: 'W67JP',
    country: 'United Kingdom',
  },
}

export const ISubscriptionData = {
  id: 101,
  title: 'Inventory Management',
  logo: 'inv_man',
  plan_kind: 0,
  pro_price: 4.99,
  plan_lines: [
    {
      title: 'Item Library & Modifiers',
      active: true,
      lite: 'Inactive',
      premium: 'Active',
    },
  ],
}

export const ISubscriptionInfo = {
  business: IBusinessAccount,
  store_count: '14',
  plan_name: 'Advanced',
  plan_description: '200-500 order/month',
  active_integration_partner_ids: [5, 6, 7],
  subscription_data: [ISubscriptionData],
  last_payment_amount: '14.22',
  last_payment_date: '2024-01-02',
  payment_type: 'Monthly',
  is_subscribed: true,
}

export const IBillingPlan = {
  apppair_plan_id: 1,
  name: 'Starter',
  description: 'Upto 200 Orders',
  threshold: 200,
  price_monthly: {
    value: 29,
    currency: 'GBP',
  },
  price_annually: {
    value: 290,
    currency: 'GBP',
  },
  extra_order: {
    value: 0.05,
    currency: 'GBP',
  },
}

export const ISubscriptionPlanData = {
  apppair_plans: [IBillingPlan],
  current_apppair_plan_id: 3,
  interval: 1,
  subscription_data: [ISubscriptionData],
}
